import classcat from "classcat";
import React from "react";

import { TextInput } from "@touchtech/web-baselayer-ui";

import { PhoneInput } from "@is/components/PhoneInput";
import PhoneOrEmailLabel from "@is/components/PhoneOrEmailLabel";
import { PhoneOrEmailInputField } from "@is/constants";
import { CheckoutInputFields, FieldState, FieldsValidation } from "@is/types";

import css from "./CheckoutFormField.module.css";
import useManageCheckoutFormField from "./hooks/useManageCheckoutFormField";

type Props = {
  onChange: (name: CheckoutInputFields, type: string, value: string) => void;
  onSaveCheckoutInfo: () => void;
  field: FieldState;
  validation: FieldsValidation;
  phoneOrEmailField?: PhoneOrEmailInputField;
  onPhoneOrEmailChange?: (name: PhoneOrEmailInputField) => void;
};

const CheckoutFormField = ({
  field,
  validation,
  onChange,
  onSaveCheckoutInfo,
  phoneOrEmailField,
  onPhoneOrEmailChange,
}: Props) => {
  const {
    label,
    type,
    value,
    placeholder,
    handleTextInputChange,
    handlePhoneInputChange,
    isPhoneSelectedFromPhoneOrEmail,
  } = useManageCheckoutFormField({ field, phoneOrEmailField, onChange });

  return (
    <div className={css.container}>
      {field.name === CheckoutInputFields.PhoneNumberOrEmail && (
        <PhoneOrEmailLabel
          fieldName={phoneOrEmailField}
          onChange={onPhoneOrEmailChange}
          isRequired={field.isRequired}
          hasError={!!validation[field.name]?.error}
        />
      )}
      {field.name === CheckoutInputFields.PhoneNumber ||
      (isPhoneSelectedFromPhoneOrEmail &&
        field.name === CheckoutInputFields.PhoneNumberOrEmail) ? (
        <PhoneInput
          label={label}
          width="full"
          error={validation[field.name]?.error}
          disabled={field.isDisabled}
          required={field.isRequired}
          value={value}
          onChange={handlePhoneInputChange}
          onChanged={onSaveCheckoutInfo}
        />
      ) : (
        <TextInput
          key={field.id}
          onChange={handleTextInputChange}
          onBlur={onSaveCheckoutInfo}
          label={label}
          name={field.name}
          width="full"
          error={validation[field.name]?.error}
          disabled={field.isDisabled}
          required={field.isRequired}
          value={value}
          placeholder={placeholder}
          autoComplete="new-password"
          data-testid={field.name}
          type={type}
          autoCapitalize="sentences"
        />
      )}
      {validation[field.name].message && (
        <div className={classcat(["text-label-base", css.errorMessage])}>
          {validation[field.name].message}
        </div>
      )}
    </div>
  );
};

export default CheckoutFormField;
